<script>
  import Carto from "./Carto.svelte"
  import Resizer from "$lib/components/guardian/Resizer.svelte"
  const defaultGeoJsonStyles = [
    {
      id: "geojson-outline",
      type: "line",
      source: "overlays",
      paint: {
        "line-color": "#1e88e5",
        "line-width": 2,
      },
    },
    {
      id: "geojson-fill",
      type: "fill",
      source: "overlays",
      paint: {
        "fill-color": "#1e88e5",
        "fill-opacity": 0.35,
      },
    },
  ]

  let { name, geoJsonURL = "", geoJsonStyles = defaultGeoJsonStyles } = $props()
</script>

<Resizer atomName="#{name}" />

<Carto
  geoJsonURL={geoJsonURL}
  geoJsonStyles={geoJsonStyles}
  MAP_INTERACTIVE={true}
  center={[151.5, -25.5]}
  zoom={6}
  headline="Torrential rain across Australia"
  subtitle={`Showing daily rainfall totals for selected weather stations from March 6`}
  source="Guardian graphic. Source: Bureau of Meteorology"
/>

<style lang="scss">
</style>
